import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Heart, ExternalLink } from "lucide-react";
import SEO from "../components/seo/SEO";
import Breadcrumbs from "../components/seo/Breadcrumbs";
import { MAIN_SITE_URL } from "../config/articles";
import { CALCULATORS } from "../config/calculators";

export default function About() {
  return (
    <>
      <SEO title="About MyFinancesGuru Tools — Free Canadian Financial Calculators" description="MyFinancesGuru Tools offers free, trustworthy Canadian financial calculators. Learn about our free-value-first approach and privacy-first calculations." path="/about" />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "About", to: "/about" }]} />
        <h1 className="font-heading text-4xl font-bold tracking-tight text-foreground sm:text-5xl">About MyFinancesGuru Tools</h1>
        <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
          MyFinancesGuru Tools is a free collection of {CALCULATORS.length} Canadian financial calculators built to help everyday Canadians make confident money decisions — from mortgages and TFSAs to retirement and debt payoff.
        </p>
        <p className="mt-4 text-base leading-relaxed text-foreground/80">
          It's a companion to the <a href={MAIN_SITE_URL} target="_blank" rel="noopener noreferrer" className="font-medium text-brand hover:text-action">MyFinancesGuru blog <ExternalLink className="inline h-3.5 w-3.5" /></a>, giving you interactive tools alongside the guides you already trust.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-3">
          {[
            { icon: Heart, title: "Free value first", desc: "Every calculator is 100% free. No paywalls on the math." },
            { icon: Lock, title: "Privacy first", desc: "Calculations run in your browser. We never store your financial inputs." },
            { icon: ShieldCheck, title: "Canada-specific", desc: "Built around Canadian rules, with dated and sourced data." },
          ].map((f) => (
            <div key={f.title} className="rounded-2xl border border-border bg-card p-6">
              <f.icon className="h-6 w-6 text-brand" />
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground">{f.title}</h3>
              <p className="mt-1 text-sm text-muted-foreground">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900">
          <strong>Not financial advice.</strong> Our tools provide general educational estimates only. Always consult a qualified professional before making financial decisions.
        </div>

        <div className="mt-10 flex gap-4">
          <Link to="/calculators" className="rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-hover">Explore calculators</Link>
          <Link to="/contact" className="rounded-full border border-border px-6 py-3 text-sm font-semibold transition-colors hover:border-brand hover:text-brand">Contact us</Link>
        </div>
      </div>
    </>
  );
}
